import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Home from './pages/Home';
import FAQ from './pages/FAQ';
import ContractLibrary from './pages/ContractLibrary';
import ContractDetail from './pages/ContractDetail';
import Cart from './pages/Cart';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Disclaimer from './pages/Disclaimer.js';
import Header from './components/Header.js';
import Footer from './components/Footer.js';

import { NavigationProvider } from './middleware/Navigation.jsx';
import { CartProvider } from './middleware/TrackCart.jsx';

function App() {
  return (
    <Router>
      <main className="App">
        <NavigationProvider>
          <CartProvider>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/library" element={<ContractLibrary />} />
              <Route path="/contract/:handle" element={<ContractDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/post/:slug" element={<BlogPost />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
            </Routes>
            <Footer />
          </CartProvider>
        </NavigationProvider>
      </main>
    </Router>
  );
}

export default App;
